import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
function Columnizer(_ref) {
  let {
    items,
    columns = 1,
    columnClasses
  } = _ref;
  const renderColumns = () => {
    const firstItems = items.slice(0);
    const itemsPerColumn = Math.ceil(items.length / columns);
    const columnElements = [];
    const classNames = clsx('col', columnClasses);
    while (firstItems.length) {
      const element = /*#__PURE__*/_jsx("div", {
        className: classNames,
        children: firstItems.splice(0, itemsPerColumn)
      }, firstItems.length);
      columnElements.push(element);
    }
    return columnElements;
  };
  const containerClasses = clsx({
    row: columns
  });
  return /*#__PURE__*/_jsx("div", {
    className: containerClasses,
    children: renderColumns()
  });
}
export default Columnizer;